import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Calendar = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      color={iconColor}
      strokeLinejoin="round"
      className="prefix__feather prefix__feather-calendar"
    >
      <title>{iconTitle}</title>
      <rect x={3} y={4} width={18} height={18} rx={2} ry={2} />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  );
};

Calendar.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Calendar.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};
export default withTheme(Calendar);
